import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import logo from "../../../assets/download.svg";
import Image from "mui-image";
import { Link } from "react-router-dom";
import Container from "@mui/material/Container";

interface Props {
  window?: () => Window;
}

const drawerWidth = 240;
const navItems = ["About Us", "Our Work", "Blog", "Ebooks", "Contact"];

export default function Header(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        <Image
          src={logo}
          alt="logo"
          width="161px"
          height="30px"
          style={{ marginLeft: "30px" }}
        />
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Link to="/contact" style={{ textDecoration: "none" }}>
        <div className="button_slide slide_down">Contact Us </div>
      </Link>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        component="nav"
        position="fixed"
        sx={{
          backgroundColor: "#FFFFFF",
          boxShadow: "rgba(0, 0, 0, 0.07) 0px -1px 38px",
          transition: "all 0.5s ease-in-out 0s",
        }}
      >
        <Container maxWidth="lg">
          <Toolbar>
            <Typography
              variant="h6"
              component="div"
              sx={{
                // flexGrow: 0,
                margin: "7px 0 0",
                display: { xs: "none", md: "block" },
              }}
            >
              <Link to="/">
                <Image
                  style={{ marginRight: "20px", display: "flex" }}
                  src={logo}
                  alt="logo"
                  width="161px"
                  height="30px"
                />
              </Link>
            </Typography>
            <Box
              sx={{ display: { xs: "none", md: "block" }, flex: "1 1 auto" }}
            >
              {navItems.map((item, i) => (
                <Link
                  style={{
                    color: "rgba(61, 61, 61, 0.65)",
                    textTransform: "capitalize",
                    transition: "all 0.3s ease-in-out 0s",
                    textDecoration: "none",
                    marginLeft: "20px",
                    fontWeight: "bold",
                  }}
                  to={`/${item}`}
                  key={i}
                >
                  {item}
                </Link>
              ))}
            </Box>
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Link to="/contact" style={{ textDecoration: "none" }}>
                <div className="button_slide slide_down">Contact Us </div>
              </Link>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: { xs: "100%", sm: "100%", md: "0" },
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 0,
                  margin: "7px 0 0",
                  display: { xs: "block", md: "none" },
                }}
              >
                <Image
                  style={{ marginRight: 0 }}
                  src={logo}
                  alt="logo"
                  width="161px"
                  height="30px"
                />
              </Typography>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px",
                }}
              >
                <IconButton
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ display: { md: "none" }, color: "rgb(239, 83, 102)" }}
                >
                  <MenuIcon />
                </IconButton>
                <Typography
                  variant="h6"
                  sx={{
                    mr: 2,
                    display: { md: "none" },
                    fontFamily: "CircularStdBold",
                    color: "rgb(239, 83, 102)",
                    fontSize: "18px",
                    lineHeight: "18px",
                    fontWeight: "500",
                    letterSpacing: "0.21px",
                    marginTop: "12px",
                  }}
                >
                  Menu
                </Typography>
              </span>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}
